export default __webpack_public_path__ + "assets/models/plane.glb";
